import urls from "../utils/urls"
import { post} from '../utils/http'
const state= {
    
    result:{},
  
    code:0,
    page:1,
    olddata:[]
   
    
}

const mutations={
   
    
    GoodsAgent(state,value){

        post(urls.admin.price.agent,value).then((result)=>{


            state.result= result
            // state.result=result
          
            
          
         
             
          });
    },

    getPurchaseData(state,val){
        

     
        post(urls.admin.purchase_order.index,val).then((result)=>{
          
          
          
          state.result=result
          
       
       
        
       
           
        });
        
    },
   
   
   
}
const  actions={
    getPurchaseDataAction(context,value){
        
        context.commit("getPurchaseData",value)
       
    },

    GoodsAgentAction(context,value){
       
        
        context.commit("GoodsAgent",value)
       
    },
   
    
   
  
    
  
    
   

}

export default {state,mutations,actions}